import React from 'react';
import '../Offering/Offering.css';
import PDF from './assets/Ärztliche-Bescheinigung.pdf';




const Certificates = () => {
    return (
        <div className='Foerderung'>
            <div className="BeratungWrapper">
                <div className='entrycontent'>

                    <h2 className='header'>Ärztliche Bescheinigung</h2>

                    <p className='text'>
                        Hier finden Sie eine Bescheinigung zum Vorlegen 
                        bei Ihrem Arzt. 
                    </p>
                    <br></br>

                    <p><a href={PDF} className='showLink'>Ärztliche Bescheinigung</a></p>

                    <br />
                    <br></br>
                    <br></br>
                    <br></br>
                </div>

            </div >

    </div>
    );
}

export default Certificates;